// activityNewUser4
export default {
  routerTitle: '新客戶四重獎賞',
  shareTitle: '新客戶四重獎賞 獎勵層層加碼',
  shareDesc: '最高5000+HKD禮包 入金30W達標享3200HKD',

  or: '或',
  award: '獎',
  awardAgain: '再獎',
  cashCoupons: '現金券',
  futeStock: '股福特',
  usCurrency: '美元',

  cardOneLabel1: '註冊送行情',
  cardOneValue11: '內地客戶送30天港股LV2行情',
  cardOneValue12: '完成簽署送30天美股LV1行情',
  cardOneLabel2: '開戶送 HKD 2256 禮包',
  cardOneValue21: '180天港股LV2串流報價行情',
  cardOneValue22: '180天美股LV1行情',
  cardOneDesc: '註：香港及海外地區港股行情為LV1',

  cardTwoTitle: '首入金2萬以上最高贈送 HKD 600 禮包',
  cardTwoTable1: '首入金 HKD 20,000 - 299,999',
  cardTwoTable1Row1: '30天內無出金且交易一次',
  cardTwoTable2: '首次認購投資組合獎勵',
  cardTwoTable2Row1: '1000-4999美元',
  cardTwoTable2Row2: '5000-9999美元',
  cardTwoTable2Row3: '10000美元以上',

  cardThreeTitle: '首入金30萬以上最高贈送 HKD 3200 禮包',
  cardThreeTable1: '首入金 HKD 30萬 以上',
  cardThreeTable1Row1: '30天內無出金且交易一次',
  cardThreeTable2: '交易額達標獎勵',
  cardThreeTable2Row11: '30天內無出金',
  cardThreeTable2Row12: '且交易額達150萬',
  cardThreeTable2Row21: '60天內無出金',
  cardThreeTable2Row22: '且交易額達300萬',
  cardThreeTable2Row31: '90天內無出金',
  cardThreeTable2Row32: '且交易額達450萬',
  cardThreeTable3: '首次認購投資組合獎勵',
  cardThreeTable3Row1: '投入2萬美元且持有30天',
  cardThreeTable3Row2: '投入2萬美元且持有60天',
  cardThreeTable3Row3: '投入2萬美元且持有90天',
  cardThreeTips: '註：入金30萬以上的交易獎勵和投資組合獎勵只能二選一。',

  cardFourTitle: '首次認購投資組合最高獎勵 HKD 1000 禮包',
  cardFourTable1: '首次認購投資組合獎勵',
  cardFourTable1Row1: '1000-4999美元',
  cardFourTable1Row2: '5000-9999美元',
  cardFourTable1Row3: '10000美元以上',
  cardFourTable1RowValue: '持有60天以上獎',
  cardFourTips:
    '註：首筆入金30萬且投資組合首次認購2萬美元，並持有60天的，獲得HKD700；將不能與首次認購投資組合10000美元以上，持有60天以上再獎HKD700的獎勵重複領取。'
}
